import { defineMessages } from 'react-intl';

export default defineMessages({
  'Продати авто на Avtoprod - це легко': {
    id: 'sell_avto:seo:title',
    defaultMessage: 'Продати авто на Avtoprod - це легко',
  },
  'Швидко та легко продати авто на Avtoprod.ua. Продай автомобіль швидко та за вигідною ціною. Даруємо 300 грн на просування вашого авто.': {
    id: 'sell_avto:seo:description',
    defaultMessage:
      'Швидко та легко продати авто на Avtoprod.ua. Продай автомобіль швидко та за вигідною ціною. Даруємо 300 грн на просування вашого авто.',
  },
});
